import * as Preact from "preact"

import App from "@fae/source/models/App.js"

import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceCube from "@fae/source/data/games/ember/views/DiceCube.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./LearnToRightClickModal.less"

export default function LearnToRightClickModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            const unit = stage.units["ashe"]
            return (
                <div class="LearnToRightClickModal">
                    <div class="Fill"/>
                    <div class="Content">
                        <div class="Header">
                            <div class="BigText">Welcome!!!</div>
                            <div class="SmallText">Right-click on an item<br/>to learn more about it!!</div>
                        </div>
                        <section class="UnitsSection">
                            <Dice item={unit.items && unit.items[0]} unit={unit} stage={stage} animation="roll"/>
                        </section>
                        <div class="Footer" isVisible={window.hasRightClicked == true}>
                            <div class="SmallText" isHoverable={true} onClick={(event) => CarryOn(stage)}>[Continue]</div>
                        </div>
                    </div>
                </div>
            )
        }
    })
}
